import { addressDrawerFulfillmentMethodSelectorStyles } from "@insite/content-library/Widgets/Header/AddressDrawerFulfillmentMethodSelector";
import WhitecapColors from "@WhiteCap/Utils/WhiteCapColor";
import { css } from "styled-components";

addressDrawerFulfillmentMethodSelectorStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
        [data-test-selector="addressDrawer_SignInLink"] {
            > span {
                color: ${WhitecapColors.blue2} !important;
            }
        }
    `,
};
